export default "__VITE_ASSET__DRKsinC0__"